window.POLYGONS = {
    options: {
        map: undefined,
    },
    polygons: [],
    init: function (options) {
        return (new Promise(function (resolve, reject) {
            _.extend(window.POLYGONS.options, options);
            if (!options.map) {
                console.error('Please specify a map when creating window.POLYGONS')
                reject();
            }
            resolve();
        })).catch(error => console.log(error));
    },
    // Display an Area (e.g. Barnet) on the map. If the area is already displayed
    // it will not be re-added (it's safe to call this function just to check)
    showArea: function (areaId) {
        validate(areaId, 'integer');
        return window.POLYGONS._drawPolygon(areaId);
    },
    // Remove an Area (e.g. Barnet) from the map. If the area hasn't been added
    // this function will do nothing.
    hideArea: function (areaId) {
        validate(areaId, 'integer');
        window.POLYGONS._removePolygon(areaId);
    },
    // Display an Area (e.g. Barnet) on the map. If the area is already displayed
    // it will not be re-added (it's safe to call this function just to check)
    showSubdivision: function (subdivisionId) {
        validate(subdivisionId, 'integer');
        return window.POLYGONS._drawPolygon(subdivisionId);
    },
    // Remove an Subdivision (e.g. Barnet) from the map. If the Subdivision hasn't been added
    // this function will do nothing.
    hideSubdivision: function (subdivisionId) {
        validate(subdivisionId, 'integer');
        window.POLYGONS._removePolygon(subdivisionId);
    },
    fitBoundsToPolygon: function (polygonId) {
        validate(polygonId, 'integer');
        window.POLYGONS._drawPolygon(polygonId).then(function (polygon) {
            window.POLYGONS.options.map.fitBounds(
                polygon['control'].getBounds()
            );
        });
    },
    _removePolygon: function (polygonId) {
        validate(polygonId, 'integer');
        console.log(`Removing Area from map: ${polygonId}`);
        if (window.POLYGONS.polygons[`polygon_${polygonId}`] !== undefined) {
           window.POLYGONS.options.map.removeControl(
                window.POLYGONS.polygons[`polygon_${polygonId}`]['control']
            );
        }
    },
    _drawPolygon: function (polygonId) {
        validate(polygonId, 'integer');
        // If we already have this polygon drawn, don't do anything (except
        // emulate the axios Promsie return)
        if (window.POLYGONS.polygons[`polygon_${polygonId}`] !== undefined) {
            return (new Promise(function (resolve, reject) {
                resolve()
            })).then(function () {
                return window.POLYGONS.polygons[`polygon_${polygonId}`];
            });
        }
        return axios.get(route('polygon-waypoints.get-by-polygon', { polygon: polygonId } ))
            .then(function (response) {
                var polygonPoints = [];
                var polygon = response.data.polygon;
                var color;
                // Subdivisions should all be blue (unless otherwise set), areas should be
                // whatever their colour property is set to.
                if (polygon.color) {
                    color = polygon.color;
                } else if (polygon.type == 'subdivision') {
                    color = '#666666';
                } else {
                    // Make anything else red.
                    color = '#FF0000';
                }
                if (response.data.polygonPoints.length < 3) {
                    console.error(`Polygon ${polygonId} did not return enough PolygonPoints to draw it.`);
                    return false;
                }
                $.each(response.data.polygonPoints, function (item, polygonPoint) {
                    var polygonPoint = L.latLng(polygonPoint.lat, polygonPoint.lng)
                    polygonPoint.inoriaModel = polygonPoint;
                    polygonPoints.push(polygonPoint);
                });
                var polygonControl = L.polygon(polygonPoints, { color: color })
                window.POLYGONS.polygons[`polygon_${polygonId}`] = {
                    control: polygonControl,
                    polygon: polygon, // TODO: Remove this one, and use the more standard "model"
                    model: polygon,
                }
                window.POLYGONS.polygons[`polygon_${polygonId}`].control.inoriaModel = polygon;
                window.POLYGONS.polygons[`polygon_${polygonId}`].control.addTo(window.POLYGONS.options.map);
                polygonControl.bindTooltip(polygon.name).openTooltip();
                return window.POLYGONS.polygons[`polygon_${polygonId}`];
            });
    },
}
